import { render, staticRenderFns } from "./BubbleMapsPage.vue?vue&type=template&id=50895d2a&"
import script from "./BubbleMapsPage.vue?vue&type=script&lang=js&"
export * from "./BubbleMapsPage.vue?vue&type=script&lang=js&"
import style0 from "./BubbleMapsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BubbleMapsPage.vue"
export default component.exports